.splash {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 24px;
  background: var(--bg);
  animation: fade-in 240ms var(--ease-standard);
}

.splash__status {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--text-2);
}
